import { render } from "./ListaResultadosRoteiros.vue?vue&type=template&id=032d32b4&scoped=true"
import script from "./ListaResultadosRoteiros.vue?vue&type=script&lang=js"
export * from "./ListaResultadosRoteiros.vue?vue&type=script&lang=js"

import "./ListaResultadosRoteiros.vue?vue&type=style&index=0&id=032d32b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032d32b4"]])

export default __exports__